import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputTextAreaUI from '../../../widgets/form/InputTextAreaUI'
import Currency from '../../../components/common/Currency'
import './RepeatTransactionPage.css'

const RepeatTransactionActionModalUI = ({
  context,
  isOpen,
  item,
  actionType,
  onActionTypeChange,
  remark,
  onRemarkChange,
  errorList,
  setErrorList,
  submitted,
  onSubmit,
  onCancelClick
}) => {
  if (!item) return null

  const accountName = item.accountName || item.clientName || item.name ||
    (item.loanEntity && (item.loanEntity.accountName || item.loanEntity.accountId || item.loanEntity.loanName)) || 'Account'
  const preApprovedLoan = item.offerAmount != null
    ? item.offerAmount
    : ((item.loanEntity && item.loanEntity.termSheetAmount) != null
      ? item.loanEntity.termSheetAmount
      : (item.preApprovedLoan || item.preApprovedLoanInINR || item.preApprovedAmount || 0))

  const displayAmount = item.offerAmountF1 || item.offerAmountF5 || item.offerAmountF || Currency.format(preApprovedLoan)
  const title = actionType === 'reject' ? 'Reject Repeat Loan Offer' : 'Approve Repeat Loan Offer'
  const buttonLabel = actionType === 'reject' ? 'Confirm Reject' : 'Confirm Approve'

  const actionOptions = [
    { key: 'approve', value: 'Approve Repeat Loan Offer' },
    { key: 'reject', value: 'Reject Repeat Loan Offer' }
  ]

  return (
    <ModalFormUI
      context={context}
      titleLabel={title}
      buttonLabel={buttonLabel}
      cancelLabel='Cancel'
      isOpen={isOpen}
      onRequestClose={onCancelClick}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div className='pa_modal_client_info g_m_bottom_100'>
        <div className='g_flex_h'>
          <span className='g_muted g_small' style={{ minWidth: '130px' }}>Account Name:</span>
          <b>{accountName}</b>
        </div>
        {item.offerName && (
          <div className='g_flex_h g_m_top_25'>
            <span className='g_muted g_small' style={{ minWidth: '130px' }}>Offer Name:</span>
            <span>{item.offerName}</span>
          </div>
        )}
        <div className='g_flex_h g_m_top_25'>
          <span className='g_muted g_small' style={{ minWidth: '130px' }}>Pre-approved Amount:</span>
          <span className='g_col_green'><b>{displayAmount}</b></span>
        </div>
        {(item.latestLoanName || item.latestLoanId) && (
          <div className='g_flex_h g_m_top_25'>
            <span className='g_muted g_small' style={{ minWidth: '130px' }}>Latest Loan:</span>
            <span>{item.latestLoanName || item.latestLoanId}</span>
          </div>
        )}
      </div>

      <div className='pa_modal_action_select g_m_bottom_100'>
        <InputSelectUI
          name='actionType'
          label='Action'
          value={actionType}
          optionList={actionOptions}
          onChange={(e) => onActionTypeChange(e.target.value)}
          required={true}
        />
      </div>

      <div className='pa_modal_remarks_wrapper'>
        <InputTextAreaUI
          name='remark'
          label={actionType === 'reject' ? 'Rejection Reason *' : 'Approval Remarks / Notes'}
          help={actionType === 'reject' ? 'Please provide a clear reason for rejection' : 'Optional remarks, comments, or approval notes'}
          value={remark || ''}
          onChange={(e) => onRemarkChange(e.target.value)}
          required={actionType === 'reject'}
          autoFocus={true}
        />
      </div>
    </ModalFormUI>
  )
}

export default RepeatTransactionActionModalUI
